import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, NAV_GROUPS } from "@/lib/site-data";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B192C] border-t border-white/10 text-gray-400"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/assets/logo.png"
                alt="Fortuna Ponyva Kft. logó"
                className="w-12 h-12 rounded-md object-contain bg-white p-1 ring-1 ring-white/10"
              />
              <div className="leading-tight">
                <div className="font-heading font-bold text-white text-base">
                  {COMPANY.name}
                </div>
                <div className="text-[10px] tracking-widest uppercase text-gray-500">
                  Since 2003 · Egyedi ponyvák
                </div>
              </div>
            </Link>
            <p className="mt-5 text-sm leading-relaxed max-w-sm">
              {COMPANY.motto} Több, mint 20 év szakmai tapasztalat, minőségi
              alapanyagok, garanciával végzett munka.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="flex items-center gap-2 hover:text-[#EA580C] transition-colors"
              >
                <Phone className="w-4 h-4" /> {COMPANY.phone}
              </a>
              <a
                href={`mailto:${COMPANY.email}`}
                className="flex items-center gap-2 hover:text-[#EA580C] transition-colors"
              >
                <Mail className="w-4 h-4" /> {COMPANY.email}
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" /> {COMPANY.address}
              </div>
            </div>
          </div>

          {NAV_GROUPS.map((g) => (
            <div key={g.label} className="md:col-span-2">
              <h4 className="text-white font-heading font-semibold text-xs uppercase tracking-widest">
                {g.label}
              </h4>
              <ul className="mt-4 space-y-2 text-sm">
                {g.items.slice(0, 6).map((it) => (
                  <li key={it.to}>
                    <Link
                      to={it.to}
                      className="hover:text-[#EA580C] transition-colors"
                    >
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-center justify-between">
          <span className="text-xs text-gray-500">
            © {new Date().getFullYear()} {COMPANY.name} · Minden jog
            fenntartva.
          </span>
          <div className="flex items-center gap-5 text-xs flex-wrap justify-center md:justify-end">
            <Link to="/rolunk" className="hover:text-[#EA580C] transition-colors">Rólunk</Link>
            <Link to="/kapcsolat" className="hover:text-[#EA580C] transition-colors">Kapcsolat</Link>
            <Link to="/akciok" className="hover:text-[#EA580C] transition-colors">Akciók</Link>
            <Link to="/palyazatok" className="hover:text-[#EA580C] transition-colors">Pályázatok</Link>
            <Link to="/adatkezelesi-tajekoztato" className="hover:text-[#EA580C] transition-colors">Adatkezelési tájékoztató</Link>
            <Link to="/cookie-tajekoztato" className="hover:text-[#EA580C] transition-colors">Cookie tájékoztató</Link>
            <a
              href={COMPANY.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#EA580C] transition-colors"
            >
              Facebook
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
